export default {
  props: {
    /**
      * HTTP method used when submitting form
      */
    method: {type: String, default: 'GET'}
  }
};
